
import setupProperitiesService from "../Services/SetupProperitiesService";

class SetupProperitiesHandler {
    save() {
        return setupProperitiesService.list().then((response) => this.setupProperities = response);
    }
    get(value) {
        return this.setupProperities[value]
    }
}

const setupProperitiesHandler = new SetupProperitiesHandler();
export default setupProperitiesHandler;